import { useQuery } from '@tanstack/react-query';
import { getApprovalGuide, getApprovalGuideByDocTitle } from '../api'; // 새로운 API 함수 임포트

// React Query 키 정의
const APPROVAL_GUIDE_QUERY_KEY = 'approvalGuide';

/**
 * useApprovalGuideQuery 훅
 * 결재라인 가이드 정보를 가져오는 React Query 훅
 * @param {object} options - React Query의 useQuery 훅에 전달할 옵션
 * @param {string} [docTitle] - 특정 문서 제목으로 필터링할 경우 사용 (옵션)
 * @returns {import('@tanstack/react-query').UseQueryResult<ApprovalGuideResponseDTO>}
 */
export const useApprovalGuideQuery = (options, docTitle) => {
  // docTitle이 있으면 해당 docTitle을 쿼리 키에 추가
  const queryKey = docTitle ? [APPROVAL_GUIDE_QUERY_KEY, docTitle] : [APPROVAL_GUIDE_QUERY_KEY];

  // docTitle 유무에 따라 호출할 API 함수를 결정
  const queryFn = docTitle ? () => getApprovalGuideByDocTitle(docTitle) : getApprovalGuide;

  return useQuery({
    queryKey: queryKey,
    queryFn: queryFn,
    // staleTime: 5분으로 설정하여 불필요한 API 호출 최소화
    staleTime: 1000 * 60 * 5,
    ...options, // enabled, onSuccess 등 외부에서 전달된 옵션 적용
  });
};
